import { render, staticRenderFns } from "./ParamOcorrenciaOrigem.vue?vue&type=template&id=7e364e24"
import script from "./ParamOcorrenciaOrigem.vue?vue&type=script&lang=js"
export * from "./ParamOcorrenciaOrigem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports